module.exports = __webpack_public_path__ + "assets/img/course-act-bg3.faaa6028.png";